import {HighSchoolOnboardingForm} from 'src/views/high-school/Onboarding/types';
import {CitizenshipOptions} from '../types/enums';
import {MANUALLY_SELECTED_DECLINE_TO_STATE} from '../components/form/onboarding/Citizenship/Citizenship';

const determineCitizenship = (isUsCitizenOrResident: boolean | null): CitizenshipOptions | null => {
  const manuallySetCitizenshipToDecline =
    window.sessionStorage.getItem(MANUALLY_SELECTED_DECLINE_TO_STATE) === 'true';

  if (isUsCitizenOrResident === true) {
    return CitizenshipOptions.YES;
  } else if (isUsCitizenOrResident === false) {
    return CitizenshipOptions.NO;
  } else if (isUsCitizenOrResident === null && manuallySetCitizenshipToDecline) {
    return CitizenshipOptions.DECLINE;
  }

  return isUsCitizenOrResident;
};

export function addDefaultsToStudent<T = HighSchoolOnboardingForm>(
  student: T & {isUsCitizenOrResident: boolean | null}
): T {
  return {
    ineligibleCountry: false,
    replacementAccountType: null,
    addressLine1: '',
    city: '',
    state: '',
    postalCode: '',
    country: 'US',
    followedCollegeIds: [],
    referralEmails: [''],
    signupSkipFollowedCollegesStep: false,
    ...student,
    isUsCitizenOrResident: determineCitizenship(student.isUsCitizenOrResident),
    currentInstitution: {
      // @ts-expect-error
      ...student.currentInstitution,
    },
    highSchoolInfo: {
      // @ts-expect-error
      ...student.highSchoolInfo,
    },
  };
}
